// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","rotate-spinner":"Spinner_rotate-spinner__2D2gK"};